import { useSelector, useDispatch } from 'react-redux';
import { 
  selectCartItems,
  selectTotalItems,
  selectTotalPrice,
} from './cartSelectors';
import { 
  addToCart, 
  removeFromCart, 
  updateQuantity, 
  clearCart,
  changeUser,
} from './cartSlice';

export const useCart = () => {
  const dispatch = useDispatch();

  // Only select what's needed
  const items = useSelector(selectCartItems);
  const totalItems = useSelector(selectTotalItems);
  const totalPrice = useSelector(selectTotalPrice);

  // Re-implement isInCart locally using selected items
  const isInCart = (id) => items.some(item => item.id === id);

  return {
    cart: items,
    cartCount: totalItems,
    totalPrice,
    isInCart,
    addToCart: (item) => dispatch(addToCart(item)),
    removeFromCart: (id) => dispatch(removeFromCart(id)),
    updateQuantity: (id, newQuantity) => dispatch(updateQuantity({ id, newQuantity })),
    clearCart: () => dispatch(clearCart()),
    changeUser: (userId) => dispatch(changeUser(userId)),
  };
};
